import { FilterObject } from "../components/common/FilterOptions";
import { VenueCardFragment } from "../components/Pages/Map";

interface VenueCardFiltered extends VenueCardFragment {
  number: number;
}

export const filterVenues = (
  items: VenueCardFragment[],
  filterOptions: FilterObject
): VenueCardFiltered[] => {
  return items
    .map((i, idx) => ({ ...i, number: idx + 1 }))
    .filter(item => {
      let show = true;

      if (
        filterOptions.status &&
        filterOptions.status.length &&
        !filterOptions.status.includes(item.status)
      ) {
        show = false;
      }

      if (filterOptions.tag && !item.tags.includes(filterOptions.tag)) {
        show = false;
      }

      return show;
    });
};
